<template>
  <div>
    <app-navigation/>

    <div class="max-width-4 mx-auto content-wrapper impressum">
      <div class="clearfix">
        <div class="md-col-8 sm-col-12 mx-auto">
          <h1 class="h1 headline">
            Impressum
          </h1>
          <p class="bold mt4">PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer.</p>
          <p>Mag. Harald Parrainer</p>
          <p>Grabenweg 68/15</p>
          <p>6020 Innsbruck, Austria</p>
          <p><a href="tel:+436507537961" title="Telefon">+43 (0) 650 7537 961</a></p>
          <p><a href="mailto:harald.parr@gmx.at" title="Email">harald.parr@gmx.at</a></p>

          <h3 class="h2 headline pt2">Haftungshinweis</h3>
          <p class="h4">PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer übernimmt keinerlei Haftung
            für die Richtigkeit, Zuverlässigkeit und Vollständigkeit der verlinkten Seiten oder die
            Rechtmäßigkeit externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich
            deren Betreiber verantwortlich.</p>

          <h3 class="h2 headline pt2">Bilder</h3>
          <p class="h4">Mag. Harald Parrainer, Unsplash</p>

          <h3 class="h2 headline pt2">PROGRAMMIERIUNG</h3>
          <p class="h4">Andreas Lorenz</p>
          <p class="h4"><a href="https://www.ad-labs.tech" title="www.ad-labs.tech" rel="nofollow"
                           class="text-decoration-none inline-block">www.ad-labs.tech</a></p>

          <h2 class="h2 headline pt2">Datenschutzerklärung</h2>
          <p class="h4">Wir legen großen Wert auf den Schutz Ihrer Daten. Um Sie über die Verwendung
            von personenbezogenen Daten umfassend zu informieren, bitten wir Sie, die folgenden
            Datenschutzrichtlinien zu beachten.</p>

          <h3 class="h2 headline pt2">Wichtiger Hinweis</h3>
          <p>Im Interesse einer besseren Lesbarkeit der Inhalte dieser Website oder in unseren
            verschiedenen sozialen Netzwerken, in denen wir aktiv sind, haben wir entweder die
            männliche oder die weibliche Form von Personennamen gewählt. Dies impliziert keine
            Diskriminierung des anderen Geschlechts. Wenn wir zum Beispiel von Besuchern oder
            Mitarbeitern sprechen, meinen wir damit gleichermaßen und natürlich auch Besucher. Alle
            Informationen richten sich an Frauen und Männer gleichermaßen.</p>
          <p>Diese Website ist leider nicht voll funktionsfähig für Personen mit körperlichen
            Einschränkungen wie Sehen, Hören oder Motorik. Wir entschuldigen uns für die dadurch
            entstehenden Unannehmlichkeiten. Wir möchten Ihre Aufmerksamkeit auf die
            Schlichtungsstelle für die Gleichstellung behinderter Menschen lenken. <a
                href="https://www.sozialministeriumservice.at/site/Behindertengleichstellung/Schlichtung">Ministerium
              für soziale Angelegenheiten der Republik Österreich</a>.</p>
          <p>Wir behalten uns das Recht vor, Änderungen am Grundprogramm vorzunehmen. Irrtümer und
            Fehler sind trotz sorgfältiger Prüfung vorbehalten. Inhalt des Online-Angebots</p>
          <p>PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer übernimmt keinerlei Gewähr für die
            Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten
            Informationen. Haftungsansprüche gegen die PSYCHOLOGISCHE PRAXIS - Mag. Harald
            Parrainer, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die
            Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung
            fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich
            ausgeschlossen, sofern seitens der PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer kein
            nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote
            sind freibleibend und unverbindlich. PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer
            behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne
            gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung
            zeitweise oder endgültig einzustellen.</p>

          <h3 class="h2 headline pt2">Verweise und Links</h3>

          <p>Bei direkten oder indirekten Verweisen auf fremde Internetseiten, sog. "Links", die
            außerhalb des Verantwortungsbereiches der PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer
            liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in
            dem PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer von den Inhalten Kenntnis hat und es
            technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu
            verhindern. PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer erklärt hiermit ausdrücklich,
            dass zum Zeitpunkt der Linksetzung die verlinkten Seiten frei von illegalen Inhalten
            waren. PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer hat keinerlei Einfluss auf die
            aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der gelinkten
            bzw. verknüpften Seiten. Deshalb distanzieren sich die PSYCHOLOGISCHE PRAXIS - Mag.
            Harald Parrainer hiermit ausdrücklich von allen Inhalten aller gelinkten Seiten, die
            nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des
            eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom
            Unternehmen eingerichteten Gästebüchern, Diskussionsforen, Mailinglisten und
            dergleichen. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für
            Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen
            entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht
            derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.</p>

          <h3 class="h2 headline pt2">Urheber- und Markenrecht</h3>

          <p>PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer ist bestrebt, in allen Publikationen die
            Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu
            beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu
            nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte
            zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte
            geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des
            jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen
            Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass
            Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für
            veröffentlichte, von den PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer selbst erstellte
            Objekte bleibt allein beim Eigentümer der Seiten. Eine Vervielfältigung oder Verwendung
            solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder
            gedruckten Publikationen ist ohne ausdrückliche Zustimmung der PSYCHOLOGISCHE PRAXIS -
            Mag. Harald Parrainer nicht gestattet.</p>

          <h3 class="h1 headline pt2">Copyright / Haftung</h3>

          <h2 class="h2 headline pt2">Weiteres</h2>

          <p>Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht,
            nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des
            Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.</p>

          <h3 class="h2 headline pt2">Cookies</h3>

          <p>Cookies sind kleine Dateien, die es dieser Website ermöglichen, während des Besuchs auf
            unserer Website spezifische nutzerbezogene Informationen auf dem Computer des Besuchers
            zu speichern. Cookies helfen uns, die Nutzungshäufigkeit und die Anzahl der Nutzer
            unserer Internetseiten zu ermitteln sowie unsere Angebote für Sie komfortabel und
            effizient zu gestalten. Wir verwenden sowohl Session-Cookies, die nur für die Dauer
            Ihrer Nutzung unserer Website temporär gespeichert werden, als auch permanente Cookies,
            um Informationen über Besucher, die wiederholt auf unsere Website zugreifen, zu
            speichern. Der Zweck des Einsatzes dieser Cookies ist es, eine optimale Benutzerführung
            zu bieten, sowie Besucher wiederzuerkennen und bei wiederholter Nutzung eine sehr
            attraktive Website und interessante Inhalte zu präsentieren. Der Inhalt eines
            permanenten Cookies ist auf eine Identifikationsnummer beschränkt. Name, IP-Adresse etc.
            werden nicht gespeichert. Es gibt kein individuelles Profil Ihres Nutzungsverhaltens.
            Eine Nutzung unserer Angebote ist auch ohne Cookies möglich. Sie können in Ihrem Browser
            Cookies deaktivieren, auf bestimmte Websites beschränken oder Ihren Webbrowser (Chrome,
            IE, Firefox, ...) so einstellen, dass er Sie benachrichtigt, wenn ein Cookie gesendet
            wird. Sie können Cookies auch jederzeit von der Festplatte Ihres PCs löschen. Bitte
            beachten Sie jedoch, dass Sie in diesem Fall mit einer eingeschränkten Darstellung der
            Seite und einer eingeschränkten Benutzerführung rechnen müssen.</p>

          <h3 class="h2 headline pt2">Datenschutzbestimmungen für die Verwendung von Google
            Analytics</h3>

          <p>Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc.
            ("Google") zur Verfügung gestellt wird. Google Analytics verwendet sog. "Cookies",
            Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der
            Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten
            Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von
            Google in den USA übertragen und dort gespeichert. Im Falle der Aktivierung der
            IP-Anonymisierung auf dieser Website wird Ihre IP-Adresse jedoch zuvor von Google in den
            Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens
            über den Europäischen Wirtschaftsraum verkürzt dargestellt. Nur in Ausnahmefällen wird
            die vollständige IP-Adresse an einen Server von Google in den USA übertragen und dort
            abgekürzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen
            benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die
            Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der
            Internetnutzung verbundene Dienstleistungen gegen den Websitebetreiber zu erbringen. Die
            von Ihrem Browser im Rahmen von Google Analytics übermittelte IP-Adresse wird nicht mit
            anderen Daten von Google zusammengeführt. Sie können das Speichern von Cookies durch
            eine entsprechende Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch
            darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser
            Website voll umfänglich nutzen können. Darüber hinaus können Sie die Verarbeitung der
            durch den Cookie erzeugten Daten (einschließlich Ihrer IP-Adresse) und Ihre Nutzung der
            Website (einschließlich Ihrer IP-Adresse) sowie die Verarbeitung dieser Daten durch
            Google verhindern, indem Sie auf den unten stehenden Link
            <a href="tools.google.com/dlpage/gaoptout?hl=en"
               title="Google"
               rel="nofollow"
               class="text-decoration-none inline-block">tools.google.com/dlpage/gaoptout?hl=en </a>
            klicken und das verfügbare Browser-Plugin herunterladen und installieren.

          </p>

          <p>
            Weitere Informationen über die Nutzungsbedingungen und den Datenschutz finden Sie unter
            <a href="http://www.google.com/analytics/terms/de.html" title="Google"
               rel="nofollow"
               class="text-decoration-none inline-block">http://www.google.com/analytics/terms/de.html</a>.
            Wir weisen darauf hin, dass auf dieser Website Google Analytics um den Code
            "gat._anonymizeIp ();" erweitert wurde, um eine anonymisierte Erfassung der IP-Adressen
            zu gewährleisten (sog. IP-Maskierung).
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Impressum',
  metaInfo: {
    meta: [
      { name: 'robots', content: 'nofollow' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Impressum.vue